import React from "react";
import { Facebook, Instagram, LinkedIn } from "@material-ui/icons";
import "./Person.style.css";

function Sevak({ person }) {
  return (
    <div className="person h-100 w-100">
      <img src={person.imageUrl} alt={person.name} />
      <div className="details">
        <p className="name">{person.name}</p>
        <p className="designation">{person.designation}</p>
        <div className="social">
          {!(person.social.facebook === "") && (
            <a href={person.social.facebook}>
              <Facebook />
            </a>
          )}
          {!(person.social.linkedin === "") && (
            <a href={person.social.linkedin}>
              <LinkedIn />
            </a>
          )}

          {!(person.social.instagram === "") && (
            <a href={person.social.instagram}>
              <Instagram />
            </a>
          )}
        </div>
        <div className="about scrollbar-hide">
          <p> {person.about} </p>
        </div>
      </div>
    </div>
  );
}

export default Sevak;
